(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6544],{

/***/ 66117:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/explore",
      function () {
        return __webpack_require__(9099);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 96301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _generated_globalTypes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79967);
/* harmony import */ var _contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73739);





var ref = next_config__WEBPACK_IMPORTED_MODULE_1___default()(), NEXT_PUBLIC_APP_URL = ref.publicRuntimeConfig.NEXT_PUBLIC_APP_URL;
var PageMeta = function(param) {
    var hrefLangLinks = param.hrefLangLinks, title = param.title, canonicalUrl = param.canonicalUrl, metaDescriptions = param.metaDescriptions, metaKeywords = param.metaKeywords, _paginationPageCount = param.paginationPageCount, paginationPageCount = _paginationPageCount === void 0 ? 1 : _paginationPageCount, _paginationCurrentPage = param.paginationCurrentPage, paginationCurrentPage = _paginationCurrentPage === void 0 ? 1 : _paginationCurrentPage, isCostGuidePage = param.isCostGuidePage, seoSegmentNamePlural = param.seoSegmentNamePlural, isCampsAndActivitiesPage = param.isCampsAndActivitiesPage;
    var ref = (0,_contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_4__/* .usePageAttributes */ .l)(), segmentNamePlural = ref.segmentNamePlural, pageType = ref.pageType, city = ref.city, state = ref.state;
    var logoPath = "".concat(NEXT_PUBLIC_APP_URL, "/img/care-no-tag.jpg?v=2");
    var prevLink;
    var nextLink;
    var canonicalPageUrl;
    var newTitle;
    var noindexPage = pageType === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_3__/* .SEOSegmentationPageType.LOCAL */ .a6.LOCAL && paginationCurrentPage > 1 || isCampsAndActivitiesPage && paginationCurrentPage > 1;
    if (paginationCurrentPage > 1) {
        if (pageType === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_3__/* .SEOSegmentationPageType.LOCAL */ .a6.LOCAL) {
            newTitle = "Page ".concat(paginationCurrentPage, " - Top ").concat(segmentNamePlural, " in ").concat(city, ", ").concat(state);
        } else {
            newTitle = "Page ".concat(paginationCurrentPage, " - Top ").concat(seoSegmentNamePlural !== null && seoSegmentNamePlural !== void 0 ? seoSegmentNamePlural : segmentNamePlural);
        }
        canonicalPageUrl = "".concat(canonicalUrl, "-page").concat(paginationCurrentPage);
        if (paginationCurrentPage < paginationPageCount) {
            nextLink = "".concat(canonicalUrl, "-page").concat(paginationCurrentPage + 1);
            prevLink = paginationCurrentPage === 2 ? canonicalUrl : "".concat(canonicalUrl, "-page").concat(paginationCurrentPage - 1);
        } else {
            prevLink = "".concat(canonicalUrl);
        }
    } else if (paginationCurrentPage === 1) {
        newTitle = title;
        canonicalPageUrl = canonicalUrl;
        if (paginationPageCount > 1) {
            nextLink = "".concat(canonicalUrl, "-page2");
        }
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            hrefLangLinks && hrefLangLinks.map(function(param) {
                var languageCode = param.languageCode, countryCode = param.countryCode, url = param.url;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "alternate",
                    href: url,
                    hrefLang: "".concat(languageCode, "-").concat(countryCode)
                }, url);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: newTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                httpEquiv: "X-UA-Compatible",
                content: "IE=edge,chrome=1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: metaDescriptions
            }),
            metaKeywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: metaKeywords
            }),
            noindexPage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex, follow"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalPageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1.0"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "verify-v1",
                content: "zz15lR180u9eCqTfur/9l+bMP75AampYtDEm6OnbkWY="
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: newTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: logoPath
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: metaDescriptions
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: "Care.com"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: "image/jpeg",
                property: "og:image:type"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: "1080",
                property: "og:image:width"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: "1080",
                property: "og:image:height"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "fb:page_id",
                content: "6030284861"
            }),
            isCostGuidePage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "shortcut icon",
                href: "https://www.care.com/img/crcm-favicon.ico"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Organization",
                        logo: logoPath,
                        name: "Care.com",
                        sameAs: [
                            "https://www.facebook.com/caredotcom/",
                            "https://twitter.com/CareDotCom",
                            "https://www.instagram.com/careorg/",
                            "https://www.linkedin.com/company/care-com", 
                        ],
                        url: "https://www.care.com"
                    })
                }
            }),
            !isCostGuidePage && nextLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "next",
                href: nextLink
            }),
            !isCostGuidePage && prevLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "prev",
                href: prevLink
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageMeta);


/***/ }),

/***/ 9099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* reexport */ campsAndActivities_LandingPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@care/navigation/dist/components/CoreGlobalFooter/CoreGlobalFooter.js + 13 modules
var CoreGlobalFooter = __webpack_require__(79976);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/PageMeta.tsx
var PageMeta = __webpack_require__(96301);
// EXTERNAL MODULE: ./src/components/common/SeoGlobalNavbar.tsx + 10 modules
var SeoGlobalNavbar = __webpack_require__(28528);
// EXTERNAL MODULE: ./src/components/hooks/useFeatureFlag.ts
var useFeatureFlag = __webpack_require__(19500);
// EXTERNAL MODULE: ./src/lib/analyticsHelper.tsx
var analyticsHelper = __webpack_require__(883);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(80822);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Card/Card.js
var Card = __webpack_require__(37088);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./src/components/hooks/useResponsive.tsx
var useResponsive = __webpack_require__(19147);
;// CONCATENATED MODULE: ./src/components/pages/campsAndActivities/HeroContent.tsx



var HeroContent = function() {
    var isSmallViewport = (0,useResponsive/* useResponsive */.F)().isSmallViewport;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        px: {
            xs: 0,
            sm: 6,
            lg: 9
        },
        pt: {
            xs: 1,
            sm: 2,
            md: 6,
            lg: 8
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: isSmallViewport ? "h1" : "display2",
                    my: 0,
                    mb: 2,
                    children: [
                        "Find kids activities and camps—",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "without the headaches"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mb: {
                    xs: 3,
                    sm: 4
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body1",
                    fontWeight: 400,
                    children: "Browse, compare, and book classes, after-school programs, and mores—all in one place."
                })
            })
        ]
    });
};
/* harmony default export */ var campsAndActivities_HeroContent = (HeroContent);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/lodash-es/orderBy.js + 10 modules
var orderBy = __webpack_require__(92580);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Select/Select.js
var Select = __webpack_require__(92817);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/TextField/TextField.js
var TextField = __webpack_require__(53340);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Modal/Modal.js + 5 modules
var Modal = __webpack_require__(387);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilityChevron.js
var Icon24UtilityChevron = __webpack_require__(68720);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24InfoLocation.js
var Icon24InfoLocation = __webpack_require__(59242);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilitySearch.js
var Icon24UtilitySearch = __webpack_require__(85594);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilityChevronLeft.js
var Icon24UtilityChevronLeft = __webpack_require__(12330);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/FormControl.js + 1 modules
var FormControl = __webpack_require__(94054);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(18972);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputAdornment/InputAdornment.js + 1 modules
var InputAdornment = __webpack_require__(87109);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(69417);
;// CONCATENATED MODULE: ./src/components/pages/campsAndActivities/CampsAndActivitiesSearch.tsx













var ZipCodeRegex = /^\d{0,5}$/;
var capitalizeFirstLetter = function(string) {
    if (!string) return string;
    return string.charAt(0).toUpperCase() + string.slice(1);
};
var prefillZipCode = function(userGeoInfo) {
    var zipCodeRegex = /zip=(\d{5})/;
    var match = zipCodeRegex.exec(userGeoInfo);
    if (match === null || match === void 0 ? void 0 : match[1]) {
        return match[1];
    }
    return "";
};
var CampsAndActivitiesSearch = function(param) {
    var userGeoInfo = param.userGeoInfo, activityCategoryLinkSections = param.activityCategoryLinkSections;
    var router = (0,next_router.useRouter)();
    var ref = (0,useResponsive/* useResponsive */.F)(), isSmallViewport = ref.isSmallViewport, isMediumViewport = ref.isMediumViewport;
    var zipInputRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(""), selectedCategory = ref1[0], setSelectedCategory = ref1[1];
    var ref2 = (0,react.useState)(""), selectedSubCategory = ref2[0], setSelectedSubCategory = ref2[1];
    var ref3 = (0,react.useState)(""), zipCodeValue = ref3[0], setZipCodeValue = ref3[1];
    var ref4 = (0,react.useState)(false), openActivitySearchModal = ref4[0], setOpenActivitySearchModal = ref4[1];
    var ref5 = (0,react.useState)([]), categoryOptions = ref5[0], setCategoryOptions = ref5[1];
    var ref6 = (0,react.useState)([]), subCategoryOptions = ref6[0], setSubCategoryOptions = ref6[1];
    var ref7 = (0,react.useState)({}), subCategoryToCategoryMap = ref7[0], setSubCategoryToCategoryMap = ref7[1];
    var prefilledZipCode = (0,react.useMemo)(function() {
        return prefillZipCode(userGeoInfo);
    }, [
        userGeoInfo
    ]);
    var ref8 = (0,react.useState)({
        zipCode: prefilledZipCode
    }), zip = ref8[0], setZip = ref8[1];
    var handleOpenModal = function() {
        setOpenActivitySearchModal(true);
    };
    var handleCloseModal = function() {
        setOpenActivitySearchModal(false);
    };
    var handleCategoryChange = function(event) {
        var selectedCategoryId = event.target.value;
        var selectedCategoryObj = categoryOptions.find(function(category) {
            return category.id === selectedCategoryId;
        });
        setSelectedCategory(selectedCategoryId);
        var ref;
        setSubCategoryOptions((ref = selectedCategoryObj === null || selectedCategoryObj === void 0 ? void 0 : selectedCategoryObj.subCategories) !== null && ref !== void 0 ? ref : []);
        setSelectedSubCategory("");
    };
    var handleSubCategoryChange = function(event) {
        var selectedSubCategoryVal = event.target.value;
        setSelectedSubCategory(selectedSubCategoryVal);
        var relatedCategory = subCategoryToCategoryMap[selectedSubCategoryVal];
        if (relatedCategory) {
            setSelectedCategory(relatedCategory);
        }
    };
    var handleSearchButton = function() {
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.ctaInteracted */.Sj.ctaInteracted, {
            cta_type: "button",
            cta_text: "Search"
        });
        var url = "/explore/d/activities";
        if (selectedSubCategory) {
            url = selectedSubCategory;
        } else if (selectedCategory) {
            url = "/explore/d/".concat(selectedCategory.replace(/_/g, "-").toLowerCase());
        }
        if (zipCodeValue) {
            url += "?zipCode=".concat(zipCodeValue, "&_qs=1");
        }
        router.push(url, undefined, {
            shallow: false
        });
    };
    var onZipCodeChange = function(e) {
        var zipCodeVal = e.target.value;
        if (!ZipCodeRegex.test(zipCodeVal)) {
            return;
        }
        setZip(function(prevValues) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevValues), {
                zipCode: zipCodeVal
            });
        });
    };
    var onFilterOpen = function() {
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.seoFeatureInteracted */.Sj.seoFeatureInteracted, {
            feature_name: "Filter Viewed"
        });
    };
    (0,react.useEffect)(function() {
        if (activityCategoryLinkSections === null || activityCategoryLinkSections === void 0 ? void 0 : activityCategoryLinkSections.linkSections) {
            var orderedCategories = activityCategoryLinkSections.linkSections.map(function(linkSection) {
                return {
                    id: linkSection.id,
                    title: linkSection.title,
                    subCategories: (0,orderBy/* default */.Z)(linkSection.linkList.map(function(link) {
                        var url = new URL(link.url);
                        return {
                            name: link.content,
                            url: url.pathname
                        };
                    }), [
                        "name"
                    ], [
                        "asc"
                    ])
                };
            });
            var sortedCategories = (0,orderBy/* default */.Z)(orderedCategories, function(category) {
                return category.title.toLowerCase();
            });
            setCategoryOptions(sortedCategories);
            var allSubCategories = (0,orderBy/* default */.Z)(orderedCategories.flatMap(function(category) {
                return category.subCategories;
            }), [
                "name"
            ], [
                "asc"
            ]);
            setSubCategoryOptions(allSubCategories);
            var subCategoryMap = {};
            orderedCategories.forEach(function(category) {
                category.subCategories.forEach(function(subCategory) {
                    subCategoryMap[subCategory.url] = category.id;
                });
            });
            setSubCategoryToCategoryMap(subCategoryMap);
            setSelectedCategory("");
            setSelectedSubCategory("");
        }
    }, [
        activityCategoryLinkSections
    ]);
    (0,react.useEffect)(function() {
        if (zipInputRef.current) {
            zipInputRef.current.setSelectionRange(zipInputRef.current.value.length, zipInputRef.current.value.length);
            zipInputRef.current.focus();
        }
    }, [
        zip
    ]);
    (0,react.useEffect)(function() {
        if (selectedCategory || selectedSubCategory) {
            var ref;
            var ref1;
            (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.seoFeatureInteracted */.Sj.seoFeatureInteracted, {
                feature_name: "Filter Applied",
                location: zip.zipCode,
                categories: selectedCategory,
                subcategories: (ref1 = (ref = subCategoryOptions.find(function(param) {
                    var url = param.url;
                    return url === selectedSubCategory;
                })) === null || ref === void 0 ? void 0 : ref.name) !== null && ref1 !== void 0 ? ref1 : ""
            });
        }
    }, [
        zip.zipCode,
        selectedCategory,
        selectedSubCategory,
        subCategoryOptions
    ]);
    var CategorySelect = /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
        variant: "standard",
        sx: {
            width: "100%",
            backgroundColor: "background.default"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select/* default */.Z, {
            size: "medium",
            displayEmpty: true,
            value: selectedCategory,
            sx: function(theme) {
                var _obj;
                return _obj = {}, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
                    borderRadius: "30px 0 0 30px",
                    minHeight: "64px"
                }), (0,_define_property/* default */.Z)(_obj, "&:hover", {
                    backgroundColor: "background.default"
                }), _obj;
            },
            IconComponent: Icon24UtilityChevron/* default */.Z,
            inputProps: {
                name: "CategorySelect"
            },
            onOpen: onFilterOpen,
            onChange: handleCategoryChange,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                    value: "",
                    disabled: true,
                    children: "Select category"
                }, "select-category"),
                categoryOptions.map(function(category) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                        value: category.id,
                        children: constants/* ACTIVITY_CATEGORY_TITLES */._f[category.id]
                    }, category.id);
                })
            ]
        })
    });
    var SubCategorySelect = /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
        variant: "standard",
        sx: {
            width: "100%",
            backgroundColor: "background.default"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select/* default */.Z, {
            size: "medium",
            displayEmpty: true,
            disabled: selectedCategory === "COOKING" || selectedCategory === "ACTIVITIES",
            sx: function(theme) {
                return (0,_define_property/* default */.Z)({}, theme.breakpoints.up("md"), {
                    borderRadius: "0",
                    borderLeft: "none",
                    minHeight: "64px",
                    "&:hover": {
                        backgroundColor: "background.default"
                    }
                });
            },
            value: selectedSubCategory,
            IconComponent: Icon24UtilityChevron/* default */.Z,
            inputProps: {
                name: "SubCategorySelect"
            },
            onOpen: onFilterOpen,
            onChange: handleSubCategoryChange,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                    value: "",
                    disabled: true,
                    children: "Subcategories"
                }, "sub-categories"),
                subCategoryOptions.map(function(subCategory) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                        value: subCategory.url,
                        children: capitalizeFirstLetter(subCategory.name)
                    }, subCategory.url);
                })
            ]
        })
    });
    var LocationInput = /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
        id: "zipCode",
        name: "zipCode",
        inputRef: zipInputRef,
        placeholder: "ZIP code",
        value: zip.zipCode,
        onChange: onZipCodeChange,
        onBlur: function(event) {
            return setZipCodeValue(event.target.value);
        },
        InputProps: {
            startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                position: "start",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24InfoLocation/* default */.Z, {})
            })
        },
        sx: function(theme) {
            var _obj;
            return _obj = {
                width: "100%"
            }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
                "& > div:nth-of-type(1)": {
                    borderRadius: "0 30px 30px 0",
                    borderLeft: "none",
                    minHeight: "64px"
                }
            }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("xs"), {
                "& > div:nth-of-type(1)": {
                    minHeight: "64px"
                }
            }), _obj;
        }
    });
    var SearchActivity = /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
        id: "activitySearch",
        placeholder: "Search for an activity",
        sx: {
            width: "100%",
            "& > div:nth-of-type(1)": {
                minHeight: "64px"
            }
        },
        onClick: handleOpenModal,
        InputProps: {
            startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                position: "start",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilitySearch/* default */.Z, {})
            }),
            readOnly: true
        }
    });
    var SearchButton = /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        color: "primary",
        variant: "contained",
        size: "medium",
        sx: {
            height: "40px",
            fontSize: "h2.fontSize",
            fontWeight: "700",
            borderRadius: "24px",
            p: 3,
            mt: {
                xs: 1,
                sm: 0
            },
            width: {
                xs: "100%",
                sm: "170px"
            }
        },
        onClick: handleSearchButton,
        children: "Search"
    });
    var MobileView = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        direction: "column",
        spacing: 2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: true,
                children: SearchActivity
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    container: true,
                    justifyContent: "center",
                    children: SearchButton
                })
            })
        ]
    });
    var DesktopView = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        alignItems: "center",
        spacing: 2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 10,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    alignItems: "center",
                    spacing: 0,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: true,
                            children: CategorySelect
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: true,
                            children: SubCategorySelect
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: true,
                            children: LocationInput
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 2,
                children: SearchButton
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isSmallViewport || isMediumViewport ? MobileView : DesktopView,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                open: openActivitySearchModal,
                hideClose: true,
                "aria-labelledby": "camps-and-activities-search-modal",
                variant: "dynamic",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    direction: "column",
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                sx: function(theme) {
                                    var ref, ref1;
                                    return {
                                        color: (ref = theme.palette.care) === null || ref === void 0 ? void 0 : (ref1 = ref.navy) === null || ref1 === void 0 ? void 0 : ref1[900]
                                    };
                                },
                                onClick: handleCloseModal,
                                size: "small",
                                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityChevronLeft/* default */.Z, {}),
                                variant: "text",
                                children: "Go back"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: true,
                            children: CategorySelect
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: true,
                            children: SubCategorySelect
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: true,
                            children: LocationInput
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                container: true,
                                justifyContent: "center",
                                children: SearchButton
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var campsAndActivities_CampsAndActivitiesSearch = (CampsAndActivitiesSearch);

;// CONCATENATED MODULE: ./src/components/pages/campsAndActivities/HeroSection.tsx






var ref = config_default()(), NEXT_ASSET_URL = ref.publicRuntimeConfig.NEXT_ASSET_URL;
var HeroSection = function(param) {
    var userGeoInfo = param.userGeoInfo, activityCategoryLinkSections = param.activityCategoryLinkSections;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        sx: {
            backgroundImage: {
                xs: "none",
                md: "url(".concat(NEXT_ASSET_URL, "/images/campsAndActivities-hero.jpg?im=)")
            },
            backgroundSize: "cover",
            backgroundPosition: "top",
            mb: {
                xs: 3,
                sm: 8
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            px: {
                xs: 3,
                sm: 5,
                lg: 0
            },
            py: {
                xs: 2,
                sm: 2,
                md: 7
            },
            sx: {
                width: "100%",
                maxWidth: "1080px",
                margin: "0 auto"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                careVariant: "subtle",
                sx: {
                    borderRadius: {
                        xs: "0",
                        sm: "0",
                        md: "16px"
                    },
                    boxShadow: {
                        xs: "none",
                        sm: "none",
                        md: "0 0 16px rgba(0, 0, 0, 0.15)"
                    },
                    width: "100%",
                    maxWidth: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(campsAndActivities_HeroContent, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        px: {
                            xs: 0,
                            sm: 6,
                            lg: 9
                        },
                        pb: {
                            xs: 1,
                            sm: 1,
                            md: 6,
                            lg: 7
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(campsAndActivities_CampsAndActivitiesSearch, {
                            userGeoInfo: userGeoInfo !== null && userGeoInfo !== void 0 ? userGeoInfo : "",
                            activityCategoryLinkSections: activityCategoryLinkSections
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var campsAndActivities_HeroSection = (HeroSection);

// EXTERNAL MODULE: ./node_modules/@mui/material/List/List.js + 1 modules
var List = __webpack_require__(78462);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItem/ListItem.js + 4 modules
var ListItem = __webpack_require__(70891);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilityCheckmarkLarge.js
var Icon24UtilityCheckmarkLarge = __webpack_require__(54362);
;// CONCATENATED MODULE: ./src/components/pages/campsAndActivities/Seasonality.tsx





var Seasonality_ref = config_default()(), Seasonality_NEXT_ASSET_URL = Seasonality_ref.publicRuntimeConfig.NEXT_ASSET_URL;
var SEASONALITY_CONTENT = [
    {
        headline: "For when school's out for summer",
        subHeadline: "Discover full-day sports camps or week-long programs over the dog days of summer."
    },
    {
        headline: "For when school takes a break",
        subHeadline: "Keep kids engaged over spring or winter break with short-term art classes, STEM camps, and more."
    },
    {
        headline: "For when school is back in session",
        subHeadline: "Help your kid get back into the swing of things with after-school enrichment programs."
    }, 
];
function Seasonality() {
    var isSmallViewport = (0,useResponsive/* useResponsive */.F)().isSmallViewport;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        item: true,
        sx: {
            width: "100%",
            margin: "auto",
            marginTop: {
                xs: 0,
                md: 8
            },
            marginBottom: {
                xs: 1,
                md: 8
            },
            backgroundColor: "background.secondary",
            flexDirection: {
                xs: "column",
                md: "row"
            },
            flexWrap: "nowrap"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                container: true,
                item: true,
                sx: {
                    height: {
                        xs: "285px",
                        sm: "380px",
                        md: "650px"
                    },
                    width: {
                        xs: "100%",
                        md: "45%"
                    },
                    backgroundImage: {
                        xs: "url(".concat(Seasonality_NEXT_ASSET_URL, "/images/seasonality-mw.jpg?im=)"),
                        md: "url(".concat(Seasonality_NEXT_ASSET_URL, "/images/seasonality-dt.jpg?im=)")
                    },
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    overflow: "hidden",
                    pr: {
                        xs: 0,
                        xl: "189px"
                    },
                    pl: {
                        xl: 0
                    },
                    pb: "37px"
                },
                direction: "row"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    display: "flex",
                    justifyContent: "center",
                    px: 3,
                    mt: {
                        xs: 3,
                        sm: 4,
                        md: 6
                    },
                    mb: {
                        xs: 6,
                        sm: 8,
                        md: 5
                    },
                    maxWidth: {
                        xs: "500px",
                        sm: "none"
                    },
                    boxSizing: {
                        xs: "content-box",
                        sm: "border-box"
                    },
                    mx: "auto"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    item: true,
                    sx: {
                        width: "auto",
                        "> *": {
                            maxWidth: {
                                xs: "none",
                                sm: "560px",
                                md: "500px"
                            }
                        }
                    },
                    direction: "column",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: isSmallViewport ? "h1" : "display3",
                            mt: 0,
                            mb: 3,
                            children: "Engaging activities for every season"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: isSmallViewport ? "body2" : "body1",
                            sx: {
                                mb: {
                                    xs: 4,
                                    sm: 3
                                }
                            },
                            children: "Whether you're looking at summer vacation, spring break, or those after-school care gaps—we have you covered all year round."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                            children: SEASONALITY_CONTENT.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.ZP, {
                                    disableGutters: true,
                                    alignItems: "flex-start",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            sx: {
                                                flexShrink: 0,
                                                marginRight: 2
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityCheckmarkLarge/* default */.Z, {
                                                width: 22,
                                                height: 22
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: isSmallViewport ? "h3" : "h2",
                                                    mb: 1,
                                                    children: item.headline
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "body2",
                                                    mb: 1,
                                                    children: item.subHeadline
                                                })
                                            ]
                                        })
                                    ]
                                }, "point-".concat(index + 1));
                            })
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var campsAndActivities_Seasonality = (Seasonality);

// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(23795);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js
var Container = __webpack_require__(46574);
// EXTERNAL MODULE: ./node_modules/@mui/material/Accordion/Accordion.js + 3 modules
var Accordion = __webpack_require__(82280);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionDetails/AccordionDetails.js + 1 modules
var AccordionDetails = __webpack_require__(22797);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionSummary/AccordionSummary.js + 1 modules
var AccordionSummary = __webpack_require__(38895);
// EXTERNAL MODULE: ./node_modules/lodash-es/upperFirst.js + 7 modules
var upperFirst = __webpack_require__(58939);
// EXTERNAL MODULE: ./node_modules/he/he.js
var he = __webpack_require__(86492);
var he_default = /*#__PURE__*/__webpack_require__.n(he);
// EXTERNAL MODULE: ./node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(91036);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
;// CONCATENATED MODULE: ./src/components/pages/campsAndActivities/InternalLinks.tsx









var InternalLinks = function(param) {
    var activityCategoryLinkSections = param.activityCategoryLinkSections;
    var isSmallViewport = (0,useResponsive/* useResponsive */.F)().isSmallViewport;
    var links = function(linkList) {
        var sortedLinks = (0,orderBy/* default */.Z)(linkList, [
            "label"
        ], [
            "asc"
        ]);
        return sortedLinks.map(function(link) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                variant: isSmallViewport ? "link2" : "link1",
                sx: {
                    cursor: "pointer",
                    color: "text.primary",
                    lineHeight: "40px",
                    textDecoration: "underline"
                },
                href: link.address,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML: {
                        __html: sanitize_html_default()(he_default().decode((0,upperFirst/* default */.Z)(link.label)))
                    }
                })
            }, link.label);
        });
    };
    var sortedSections = (0,react.useMemo)(function() {
        var transformLinksData = function() {
            if (!activityCategoryLinkSections) return [];
            return activityCategoryLinkSections.linkSections.map(function(section) {
                return {
                    label: section.id,
                    items: section.linkList.map(function(link) {
                        return {
                            address: link.url,
                            label: link.content
                        };
                    })
                };
            })// Filter out sections where linkList is empty
            .filter(function(section) {
                return section.items.length > 0;
            });
        };
        return (0,orderBy/* default */.Z)(transformLinksData(), [
            "label"
        ], [
            "asc"
        ]);
    }, [
        activityCategoryLinkSections
    ]);
    if (isSmallViewport) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            sx: function() {
                return {
                    backgroundColor: "background.secondary",
                    px: 3,
                    py: 4,
                    mt: 4
                };
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                maxWidth: "md",
                item: true,
                xs: 12,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h1",
                        pb: 2,
                        children: "Explore all categories"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                        defaultExpanded: true,
                        elevation: 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                            sx: {
                                m: 0,
                                p: 0
                            },
                            children: sortedSections.map(function(tabSection) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
                                    elevation: 0,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSummary/* default */.Z, {
                                            sx: {
                                                width: "100%",
                                                padding: 0,
                                                "& .MuiIconButton-root": {
                                                    marginRight: "-7px"
                                                },
                                                minHeight: "48px"
                                            },
                                            expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityChevron/* default */.Z, {
                                                color: "#172C42"
                                            }),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "h3",
                                                children: constants/* ACTIVITY_CATEGORY_TITLES */._f[tabSection.label]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                                            sx: {
                                                m: 0,
                                                p: 0
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                sx: {
                                                    display: {
                                                        sm: "flex"
                                                    }
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    sx: {
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        width: "100%"
                                                    },
                                                    children: links(tabSection.items)
                                                })
                                            })
                                        })
                                    ]
                                }, tabSection.label);
                            })
                        })
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            backgroundColor: "background.secondary",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            maxWidth: "lg",
            sx: {
                pt: 2,
                pb: 6
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                children: sortedSections.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h2",
                            fontSize: "display3.fontSize",
                            textAlign: "center",
                            pt: 5,
                            pb: 8,
                            px: 0,
                            children: "Explore all categories"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                minHeight: {
                                    sm: "200px"
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                container: true,
                                spacing: 4,
                                children: sortedSections.map(function(linkSection) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        sm: 3,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                            sx: {
                                                cursor: "pointer",
                                                lineHeight: "30px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "h2",
                                                    sx: {
                                                        pb: 2
                                                    },
                                                    children: constants/* ACTIVITY_CATEGORY_TITLES */._f[linkSection.label]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    sx: {
                                                        display: {
                                                            sm: "flex"
                                                        }
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                        sx: {
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            width: "100%"
                                                        },
                                                        children: links(linkSection.items)
                                                    })
                                                })
                                            ]
                                        })
                                    }, linkSection.label);
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var campsAndActivities_InternalLinks = (InternalLinks);

;// CONCATENATED MODULE: ./src/components/pages/campsAndActivities/LandingPage.tsx













var ArticleSection = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3829), __webpack_require__.e(3845)]).then(__webpack_require__.bind(__webpack_require__, 83845));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83845)
            ];
        }
    }
});
var CategorySection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7786).then(__webpack_require__.bind(__webpack_require__, 80974));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80974)
            ];
        }
    }
});
var ValuePropSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6428).then(__webpack_require__.bind(__webpack_require__, 6428));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6428)
            ];
        }
    }
});
var LandingPage = function(param) {
    var deviceChar = param.deviceChar, userGeoInfo = param.userGeoInfo, activityCategoryLinkSections = param.activityCategoryLinkSections, seoArticlesListData = param.seoArticlesListData;
    var ref, ref1;
    var metaTitle = "Explore: kids activities, camps and classes - Care.com";
    var metaDescription = "Book the best kids activities, camps and classes from local providers";
    var canonicalUrl = "https://www.care.com/explore";
    var isCookingCategoryFlagEnabled = ((ref = (0,useFeatureFlag/* default */.Z)(constants/* UI_FEATURE_FLAGS.OOH_ACTIVITIES_COOKING_CATEGORY.id */.WV.OOH_ACTIVITIES_COOKING_CATEGORY.id)) === null || ref === void 0 ? void 0 : ref.variationIndex) === 0;
    var ref2;
    // Filter the linkSections based on the flag
    var filteredActivityCategoryLinkSections = activityCategoryLinkSections ? {
        __typename: "SEOActivityCategoryLinkSectionsSuccess",
        linkSections: (ref2 = (ref1 = activityCategoryLinkSections.linkSections) === null || ref1 === void 0 ? void 0 : ref1.filter(function(section) {
            return isCookingCategoryFlagEnabled || section.id !== "COOKING";
        })) !== null && ref2 !== void 0 ? ref2 : []
    } : null;
    (0,react.useEffect)(function() {
        var pageProperties = {
            seo_page_id: 1539,
            screen_name: "Explore landing page",
            screen_template: "Explore landing page"
        };
        if (deviceChar && Object.keys(deviceChar).length > 0) {
            (0,analyticsHelper/* setPagePropertiesFromData */.UP)(pageProperties);
            (0,analyticsHelper/* setDeviceDataFromHeaders */.xF)(deviceChar);
        }
    }, [
        deviceChar
    ]);
    (0,react.useEffect)(function() {
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.seoPageViewed */.Sj.seoPageViewed, {
            seo_page_type: "Explore landing page",
            page_template: "Explore landing page",
            seo_page_title: "Find kids activities and camps— without the headaches"
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        container: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            item: true,
            xs: 12,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default */.Z, {
                    title: metaTitle,
                    metaDescriptions: metaDescription,
                    canonicalUrl: canonicalUrl
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoGlobalNavbar/* SeoGlobalNavbar */.L, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(campsAndActivities_HeroSection, {
                    userGeoInfo: userGeoInfo,
                    activityCategoryLinkSections: filteredActivityCategoryLinkSections
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CategorySection, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ValuePropSection, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(campsAndActivities_Seasonality, {}),
                (seoArticlesListData === null || seoArticlesListData === void 0 ? void 0 : seoArticlesListData.articles) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleSection, {
                    articles: seoArticlesListData.articles
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(campsAndActivities_InternalLinks, {
                    activityCategoryLinkSections: filteredActivityCategoryLinkSections
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CoreGlobalFooter/* default */.Z, {
                    variant: "inverse"
                })
            ]
        })
    });
};
/* harmony default export */ var campsAndActivities_LandingPage = (LandingPage);

;// CONCATENATED MODULE: ./src/pages/explore.tsx
var __N_SSP = true;



/***/ }),

/***/ 75347:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 31777:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 34017:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 59905:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2453,6886,9417,9263,6877,1903,3816,6492,3044,3203,387,9644,6610,8556,8528,9774,2888,179], function() { return __webpack_exec__(66117); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);